module.exports = __webpack_public_path__ + "assets/3rdProportional.b2ebd626854d7d38b9a954d73e1b5c28.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/3rdProportional.gmt
// module id = 879
// module chunks = 0